import React, { forwardRef } from 'react';

import PropTypes from 'prop-types';

import { IBdsCardContainer } from '../../../../interfaces/cards';
import './BdsCardContainer.scss';

const BdsCardContainer = forwardRef<HTMLDivElement, React.PropsWithChildren<IBdsCardContainer>>(
  (
    {
      children,
      className,
      onClick,
      type = 'solid',
      paddingSize = 'padding-s',
      borderRadiusSize = 'radius-s',
      withMinWidth = true
    },
    ref
  ) => {
    const nameClass = [
      'bds-card-container',
      className,
      type,
      paddingSize,
      borderRadiusSize,
      withMinWidth ? 'with-min-width' : ''
    ].join(' ');
    return (
      <div data-testid="bds-card-container" onClick={onClick} className={nameClass} ref={ref}>
        {children}
      </div>
    );
  }
);

BdsCardContainer.displayName = 'BdsCardContainer';
BdsCardContainer.propTypes = {
  className: PropTypes.string,
  withMinWidth: PropTypes.bool,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['solid', 'outline-subtle']),
  paddingSize: PropTypes.oneOf(['padding-s', 'padding-m', 'padding-l', 'padding-xl']),
  borderRadiusSize: PropTypes.oneOf(['radius-s', 'radius-m', 'radius-l'])
};

export default BdsCardContainer;
